<script setup>
import SSoldeListItem from '@/components/global/s-solde-list-item.vue'
</script>

<template>
  <v-list dense nav class="text-body-1 py-0">
    <v-subheader v-if="displayEtablissement && etablissement" v-text="etablissement.raisonSociale" />
    <v-list-item-group
      v-model="selectedCongesSolde"
      color="primary"
      :value="selectedCongesSolde"
      :value-comparator="valueCompare"
    >
      <s-solde-list-item
        v-for="(type, index) in congesTypesAvecSolde"
        :key="index"
        :value="{ congesTypeId: type.congesTypeId, employeId: employeId }"
        :titre="type.label"
        unite="j"
        :soldes="[{ label: null, value: getSoldeByCongesTypeId(type.congesTypeId) }]"
      />
      <v-list-item :value="{ congesTypeId: 0, employeId: employeId }">
        <v-list-item-content class="py-1">
          <v-list-item-title justify="center" v-text="'Autres congés'" />
        </v-list-item-content>
      </v-list-item>
      <s-solde-list-item
        :value="{ congesTypeId: -1, employeId: employeId }"
        titre="Récupérations"
        :soldes="[
          { label: 'À date', value: soldeDeRecuperationADate },
          { label: 'Total', value: soldeDeRecuperationTotal },
        ]"
      />
      <s-solde-list-item
        v-if="!estEnCDI"
        inactive
        :value="null"
        texte-explication="Décompte toute heure travaillés (heures supp comprises) depuis le début du contrat courant jusqu'à ce jour/l'issue du contrat. "
        titre="Heures effectués"
        sous-titre="(contrats à durée déterminée uniquement)"
        :soldes="[
          { label: 'À date', value: soldeDheuresTravaillesADate },
          { label: 'Prévues', value: soldeDheuresTravaillesTotal },
        ]"
      />
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'employe-solde-list',
  props: {
    value: {
      type: Object,
      required: false,
      default: undefined,
    },
    employeId: {
      type: Number,
      required: true,
    },
    displayEtablissement: {
      type: Boolean,
      required: false,
      default: false,
    },
    estEnCDI: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedCongesSolde: undefined,
      soldesDheuresDeTravail: {},
    }
  },
  computed: {
    ...mapGetters({
      getCongesTypes: 'conges/getCongesTypes',
      getEmployeById: 'employe/getEmployeById',
      getEtablissementById: 'etablissement/getEtablissementById',
      utilisateur: 'security/getUtilisateur',
    }),
    loaded() {
      return !!this.employe
    },
    congesTypesAvecSolde() {
      return this.getCongesTypes.filter(
        (t) =>
          t.avecSolde &&
          (this.employe.conges.filter((c) => c.type.congesTypeId === t.congesTypeId).length > 0 ||
            this.employe.congesCredits.filter((cc) => cc.type.congesTypeId === t.congesTypeId).length > 0)
      )
    },
    employe() {
      return this.getEmployeById(this.employeId)
    },
    etablissement() {
      if (this.employe) {
        return this.getEtablissementById(this.employe.etablissement.etablissementId)
      } else {
        return undefined
      }
    },
    soldeDeRecuperationADate() {
      if (this.employe.recuperations) {
        return this.getSoldesEnHeures(this.employe.recuperations.soldeDeRecuperationADate)
      } else {
        return '-'
      }
    },
    soldeDeRecuperationTotal() {
      if (this.employe.recuperations) {
        return this.getSoldesEnHeures(this.employe.recuperations.soldeDeRecuperationTotal)
      } else {
        return '-'
      }
    },
    soldeDheuresTravaillesADate() {
      if (this.soldesDheuresDeTravail.aDate) {
        return this.getSoldesEnHeures(this.soldesDheuresDeTravail.aDate)
      } else {
        return '-'
      }
    },
    soldeDheuresTravaillesTotal() {
      if (this.soldesDheuresDeTravail.prevues) {
        return this.getSoldesEnHeures(this.soldesDheuresDeTravail.prevues)
      } else {
        return '-'
      }
    },
  },
  created() {
    this.selectedCongesSolde = this.value
  },
  watch: {
    employeId: {
      handler(employeId) {
        this.fetchRecuperationsByEmployeId(employeId)
        this.rafraichirSoldeDheuresDeTravail()
      },
      immediate: true,
    },
    selectedCongesSolde() {
      if (this.selectedCongesSolde != null) {
        this.$emit('input', this.selectedCongesSolde)
      }
    },
    value() {
      this.selectedCongesSolde = this.value
    },
  },
  methods: {
    ...mapActions({
      fetchRecuperationsByEmployeId: 'employe/fetchRecuperationById',
      obtenirSoldesDheuresDeTravailById: 'employe/obtenirSoldesDheuresDeTravailById',
    }),
    getSoldesEnHeures(solde) {
      return Math.round((solde / 60) * 100) / 100
    },
    valueCompare(a, b) {
      return a && b && a.congesTypeId === b.congesTypeId && a.employeId === b.employeId
    },
    getSoldeByCongesTypeId(_congesTypeId) {
      return this.employe.congesSoldes.find((cs) => cs.congesType.congesTypeId === _congesTypeId).solde
    },
    rafraichirSoldeDheuresDeTravail() {
      this.obtenirSoldesDheuresDeTravailById(this.employeId).then((value) => (this.soldesDheuresDeTravail = value))
    },
  },
}
</script>
